import React from 'react';
import tpl from '../templates/uo-accounts';
import {canUseDOM} from '../../../../../helpers/canUseDOM';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            search_by: [canUseDOM ? window.location.pathname : '/business/yuo']
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.updateModeBasedOnURL();
        this.checkAnchorForModal();

        this.scrollToAndActivateTab({
            paramKeys: ['open-account'],
            selector: '#open-account',
            onScrollComplete: () => {
                this.setState({showModal: true});
            }
        });
    }

    updateModeBasedOnURL() {
        const targetElement = document.getElementById('open-account');
        const currentURL = window.location.href;
        if (currentURL.includes('vidkryty_rahunok') && targetElement) {
            targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }

    checkAnchorForModal() {
        const params = new URLSearchParams(window.location.search);

        if (params.has('open_account_consult')) {
            this.setState({showModal: true});
        }
    }
}
